$shm_showcase_demo_file_drop $mol_list
	rows /
		<= Input $shm_file_drop
			files? <=> files? /File
		<= Selected $mol_text
			text <= selected \
